// Shared labels/helpers for the HR module (งานบุคลากร)

export const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api')
  .replace(/\/api\/?$/, '')
  .replace(/\/$/, '')

export const fmtDateTH = (d) =>
  d ? new Date(d).toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'

export const fmtDateTimeTH = (d) =>
  d ? new Date(d).toLocaleString('th-TH', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'

export const fmtDays = (n) => {
  const v = parseFloat(n)
  if (Number.isNaN(v)) return '-'
  return Number.isInteger(v) ? String(v) : v.toFixed(1)
}

export const EMPLOYMENT_TYPES = {
  full_time: 'ประจำ',
  contract: 'สัญญาจ้าง',
  part_time: 'บางเวลา',
  temporary: 'ชั่วคราว',
}

export const STAFF_STATUS = {
  active:   { label: 'ปฏิบัติงาน', bg: 'success' },
  on_leave: { label: 'ลาพัก',      bg: 'warning' },
  resigned: { label: 'ลาออก',      bg: 'secondary' },
  retired:  { label: 'เกษียณ',     bg: 'dark' },
}

export const TRAINING_TYPES = {
  training: { label: 'อบรม',   bg: 'info' },
  meeting:  { label: 'ประชุม',  bg: 'primary' },
  activity: { label: 'กิจกรรม', bg: 'success' },
}

export const LEAVE_STATUS = {
  pending:   { label: 'รออนุมัติ',  bg: 'warning' },
  approved:  { label: 'อนุมัติ',    bg: 'success' },
  rejected:  { label: 'ไม่อนุมัติ', bg: 'danger' },
  cancelled: { label: 'ยกเลิก',     bg: 'secondary' },
}

// 'HH:MM' or 'HH:MM:SS' -> 'HH:MM น.'
export const fmtTime = (t) => (t ? `${String(t).slice(0, 5)} น.` : '-')

export const toBE = (year) => Number(year) + 543
export const toCE = (yearBE) => Number(yearBE) - 543
